var map = {
	"./acquaintance.js": 3983,
	"./address.js": 1086,
	"./age.js": 3066,
	"./contact.js": 755,
	"./customers.js": 9226,
	"./hours.js": 3410,
	"./index.js": 6078,
	"./needs_advice.js": 6691,
	"./occupation.js": 4187,
	"./phone.js": 6558,
	"./social_media.js": 8049,
	"./team.js": 8182,
	"./whatsapp.js": 1041
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1815;